import React from 'react'
import OnlineUser from './OnlineUser'
import ScrollToBottom from 'react-scroll-to-bottom'

const SideBar = ({roomData}) => {
  return (
      <>
    <h2 style = {{color: "white"}}>Users Online</h2>
    <ScrollToBottom className="messages">
  {  roomData.map((element, id) => 
     <OnlineUser key = {id} element = {element}/>
   )}
   </ScrollToBottom>
</>
  )
}

export default SideBar